import Vue from 'vue'
import VueRouter from 'vue-router'
// pc
import Home from "../views/pc/home";
import Head from "../components/pc/head";
import Base from "../components/pc/base";
// 移动
import m_Home from "../views/mobile/home";
import m_Head from "../components/mobile/head";
import m_Base from "../components/mobile/base";

import vip from "../views/vip";
import check from "../views/check";
import storefront from "../views/storefront";
Vue.use(VueRouter)


//默认路由
export const routes = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/vip",
    name: "VIP",
    meta:{ cnname: 'VIP使用体验反馈', enname: 'Home'},
    components: { header: vip }
  },
  {
    path: "/check",
    name: "Check",
    meta:{ cnname: '妍诗美社官方认证', enname: 'Home'},
    components: { header: check }
  },
  
];
//pc端的路由
export const pcRoutes = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/home",
    name: "Home",
    meta:{ cnname: '首页', enname: 'Home'},
    components: { header: Head,default: Home,  footer: Base }
  },

];
//移动端设备路由
export const mobileRoutes = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/home",
    name: "Home",
    meta:{ cnname: '首页', enname: 'Home'},
    components: { default: m_Home, header: m_Head, footer: m_Base }
  },{
    path: "/storefront",
    name: "Storefront",
    meta:{ cnname: '普罗敦时光', enname: 'Home'},
    components: { header: storefront }
  },
   
];
 
const createRouter = () =>
  new VueRouter({
    scrollBehavior: () => ({ y: 0 }),
    mode: "history",
    routes: routes,
  });
 
const router = createRouter();
 
// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}
router.beforeEach((to, from, next)=>{
  // let str = to.path.split('/')[1] 
  // let str2 = to.path.split('/')[2] 
  // console.log(str2)
  // if(str2) {
  //   if( to.path !== '/check') {
  //     next('/check')
  //   }else {
  //     next()
  //   }
  // }else{
  //     next()
  // }
  
  if (to.meta.cnname) {
    document.title = to.meta.cnname
  }
  next()
 
})

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js